import Vue from 'vue'
import { moduleKeys } from '../config/modules'
import generateCode from './code/generate'
import apikeys from './apikey.json'
import generateCodeWs from './codeWs/generate'
import generateCodeJson from './codeJson/generate'
import { getNavMenusByLang, getRootConfigByLang } from '@/config/index'
import { LANG_KEY } from './lang'

export * from './lang'
export { generateCode, generateCodeWs, generateCodeJson }

let appConfig = Object.create(null)
let searchConfig = []

export const apikeyList = apikeys
export const getModules = (lang) => {
  let newLang = lang
  if (lang == "zh-hans") {
    newLang = "zh-cn"
  }
  if (lang == "zh-tw") {
    newLang = "zh-tw"
  }
  if (lang == "en-US") {
    newLang = "en-us"
  }
  return moduleKeys.map(item => ({ name: item, path: `/${newLang}/${item}` }))
}

const getJSONPathsByLang = (lang) => {
  /**
   * 第一个参数必须是常量
   * https://github.com/webpack/webpack/issues/4772#issuecomment-296798125
   */
  const paths = require.context('@/config/', true, /\.json$/).keys();
  return paths.filter(file => file.startsWith(`./${lang}`))
}

export const msgMap = {
  'success': {
    [LANG_KEY.zh]: '复制成功',
    [LANG_KEY.tw]: '複製成功',
    [LANG_KEY.en]: 'Copy Successfully',
  },
  'error': {
    [LANG_KEY.zh]: '复制失败',
    [LANG_KEY.tw]: '複製失敗',
    [LANG_KEY.en]: 'Copy Failed',
  }
}

const resetConfig = () => {
  appConfig = Object.create(null)
  searchConfig = []
}

const updateSearchConfig = () => {
  searchConfig = []
  for (const [key, value] of Object.entries(appConfig)) {
    const path = key
    const { name, content, moduleName } = value
    if (Array.isArray(content)) {
      let searchItem = null
      for (let i = 0; i < content.length; i++) {
        const item = content[i]
        if (!searchItem) {
          searchItem = {
            moduleName,
            path,
            name,
            texts: [],
            hash: '',
            api: '',
          }
        }
        if (item.type === 'hash') {
          if (searchItem.hash) {
            searchConfig.push(searchItem)
            i--
            searchItem = null
            continue
          }
          searchItem.hash = item.text
        } else if (item.type === 'normal') {
          if (item.text) {
            searchItem.texts.push(item.text)
          }
          if (Array.isArray(item.children)) {
            const childredTexts = item.children.filter(i => i.type === 'normal').map(i => i.text)
            searchItem.texts.push(...childredTexts)
          }
        } else if (item.type === 'demo') {
          searchItem.api = item.api ? item.api.uri : ''
        }
      }
      searchConfig.push(searchItem)
    } else if (content && typeof content === 'string') {
      searchConfig.push({
        moduleName,
        path,
        name,
        texts: [content],
        hash: '',
        api: '',
      })
    }
  }
}

export const updateAppConfigByLang = (lang) => {
  resetConfig()

  const navTexts = getNavMenusByLang(lang)
  const allData = getRootConfigByLang(lang)
  for (const key in allData) {
    allData[key].forEach(obj => {
      const rootPath = obj.path
      appConfig[rootPath] = {
        name: obj.name,
        content: obj.content,
        moduleName: navTexts[obj.module],
      }
      if (Array.isArray(obj.children)) {
        obj.children.forEach(child => {
          const key2 = `${rootPath}/${child.path}`
          appConfig[key2] = {
            name: child.name,
            content: child.content,
            moduleName: navTexts[obj.module]
          }
        })
      }
    })
  }

  // const paths = getJSONPathsByLang(lang)
  // paths.forEach(path => {
  //   const file = require(`@/config/${path.replace('./', '')}`)
  //   const rootPath = file.path

  //   appConfig[rootPath] = {
  //     name: file.name,
  //     content: file.content,
  //     moduleName: navTexts[file.module],
  //   }
  //   if (Array.isArray(file.children)) {
  //     file.children.forEach(child => {
  //       const key = `${rootPath}/${child.path}`
  //       appConfig[key] = {
  //         name: child.name,
  //         content: child.content,
  //         moduleName: navTexts[file.module],
  //       }
  //     })
  //   }
  // })



  updateSearchConfig()
}

export const getAppConfig = () => appConfig
export const getSearchConfig = () => searchConfig

export const emitter = new Vue()

export const generateId = (text) => {
  return text.split(/\s+/).join('_')
}



// WEBPACK FOOTER //
// ./src/utils/index.js